import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit, Inject, Optional, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ReportService } from '@app/_components/report';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { MatMenuItem as MatMenuItem } from '@angular/material/menu';
import { RateBucketService } from '@app/_components/rate/rate-bucket';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantService } from '@app/_services';
import { OwnerLeadProfileService } from '@app/_components/owner-lead-profile/owner-lead-profile.service';
import { TagService } from '@app/_components/task/tag/tag.service';
import { DevelopmentService } from '@app/_components/development';
import { PropertyLeadProfileService } from '@app/_components/property-lead-profile/property-lead-profile.service';
import { OwnerProfileService } from '@app/_components/owner-profile/owner-profile.service';
import { PropertyService } from '@app/_components/property/property.service';
import { RealtorProfileService } from '@app/_components/realtor-profile/realtor-profile.service';
import { EmployeeProfileService } from '@app/_components/employee-profile/employee-profile.service';
import { ContactService } from '@app/_components/contact/contact.service';
import { TagJoinService } from '@app/_components/_helpers/tag-join/tag-join.service';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { Calendar } from 'primeng/calendar';
import { ReservationService } from '@app/_components/reservation';

@Component({
    selector: 'app-search-template',
    templateUrl: './search-template.component.html',
    styleUrls: ['./search-template.component.css'],
    standalone: false
})
export class SearchTemplateComponent implements OnInit, OnChanges, AfterViewInit {

	@Output() doSearchCB = new EventEmitter<any>();
	@Output() doChangeCB = new EventEmitter<any>();
	@Output() doApplyTagCB = new EventEmitter<any>();
	@Output() doRemoveTagCB = new EventEmitter<any>();
	@Output() doSearchCBForm2 = new EventEmitter<any>();
	@Output() tagsSelectedEvent = new EventEmitter<any>();
	@Input() reset: boolean;
	@Input() reset2: boolean;
	@Input() searchLabel: string; 
	@Input() applyTagLabel: string;
	@Input() removeTagLabel: string;
	@Input() formTitle: string;
	@Input() showLocations: boolean;
	@Input() showShortTermRentals: boolean;
	@Input() shortTermRentalId: string;
	/** Optional property-code (e.g. "HKH-236") auto-selector — case-insensitive match against
	 *  shortTermRentals[].propertyCode and yielMaxProperties[].propertyCode. Triggers auto-search. */
	@Input() propertyCode: string;
	@Input() showYieldMaxProperties: boolean;
	@Input() showYieldMaxDevelopments: boolean;
	@Input() yieldMaxSelectedProperty: any;
	@Input() yieldMaxSelectedStartDate: any;
	@Input() yieldMaxSelectedEndDate: any;
	@Input() showViewTypes: boolean;
	@Input() showDevelopments: boolean;
	@Input() showRateBuckets: boolean;
	@Input() showYieldMaxRateBuckets: boolean;
	@Input() showBedrooms: boolean;
	@Input() showSleeps: boolean;
	@Input() showListingTypes: boolean;
	@Input() showSeasons: boolean;
	@Input() showPropertyRanks: boolean;
	@Input() showNumNts: boolean;
	/** Pre-select specific night counts in the LOS multiselect (e.g. [4] when opened from inbox with flexNumNights=4). */
	@Input() preSetNumNts: number[] = [];
	@Input() showReferralSources: boolean;
	@Input() showResTypes: boolean;
	@Input() showBlankStartAndEndDate: boolean;
	@Input() showStartDate: boolean;
	@Input() showEndDate: boolean;
	@Input() showSaleDateStart: boolean;
	@Input() showSaleDateEnd: boolean;
	@Input() showAddTag: boolean;
	@Input() showHoldDateStart: boolean;
	@Input() showHoldDateEnd: boolean;
	@Input() showHoldExpiredDateStart: boolean;
	@Input() showHoldExpiredDateEnd: boolean;
	@Input() showCancelDateStart: boolean;
	@Input() showCancelDateEnd: boolean;
	@Input() showCheckInDateStart: boolean;
	@Input() showCheckInDateEnd: boolean;
	@Input() showCheckOutDateStart: boolean;
	@Input() showCheckOutDateEnd: boolean;
	@Input() showFilterDateStart: boolean;
	@Input() showFilterDateEnd: boolean;
	@Input() showReservationStatus: boolean;
	@Input() showReportType: boolean;
	@Input() showResMasReportName: boolean;
	@Input() showFutureGuestDate: boolean;
	@Input() showSearchButton: boolean;
	@Input() parentScreen: string;
	@Input() showApplyTagButton: boolean;
	@Input() showRemoveTagButton: boolean;
	@Input() showSearchButtonForm2: boolean;
	@Input() showSaleYear: boolean;
	@Input() showListingStatus: boolean;
	@Input() isBulkEditing: boolean;
	@Input() showCustomDateRange: boolean; //Allow user to set custom date range as default
	@Input() dateRange: string; // custom date range --Year --Month --Day
	@Input() dateRangeNumber: number; // custom range number, number of months, days or years
	@Input() displayRecordsOnPageLoad: boolean; //Call the API on page load to display result
	@Input() showExcludeFutureGuests: boolean;
	@Input() showExcludeUnsubscribers =  false;
	@Input() showExcludeOwnerProfiles =  false;
	@Input() showReservationId =  false;
	@Input() parentId: number;
	@Input() showOwnerLeadListingStatus: boolean;
	@Input() showSubAdrIsland: boolean;
	@Input() showSubAdrCity: boolean;
	@Input() showSubjAdrState: boolean;
	@Input() showSubAdrDevelopmentName: boolean;
	@Input() showOwnerListingStatus: boolean;
	@Input() showJobCategories: boolean;
	@Input() showJobLevel: boolean;
	@Input() showTagName: boolean;
	@Input() showSubjAdrCity: boolean;
	@Input() guestProfile: boolean;
	@Input() guestMasterProfile: boolean;
	@Input() ownerLeadProfile: boolean;
	@Input() propertyLeadProfile: boolean;
	@Input() employeeProfile: boolean;
	@Input() ownerProfile: boolean;
	@Input() realtorProfile: boolean;
	@Input() contacts: boolean;

	@Input() startDate: Date;
	@Input() endDate: Date;
	
	@Input() startDateLabel: string; // customize the start label
	@Input() endDateLabel: string; // customize the end label

	// Custom labels for the filterDate pickers (default: "Filter Date Start/End").
	// Quote Analytics passes "Quote Create Start/End" so the dashboard's intent
	// is obvious to non-engineer users.
	@Input() filterDateStartLabel: string;
	@Input() filterDateEndLabel: string;

	// Custom labels for the saleDate pickers (default: "Sale Date Start/End").
	// Quote Analytics passes "Start Date"/"End Date" for a cleaner UI.
	@Input() saleDateStartLabel: string;
	@Input() saleDateEndLabel: string;

	/** When true, the filter-date pickers will NOT be auto-defaulted to yesterday.
	 *  Useful when a report uses saleDate as its primary date window instead. */
	@Input() disableFilterDateDefault: boolean = false;

	@Input() saleDateStart: Date;
	@Input() saleDateEnd: Date;

	@Input() holdDateStart: Date;
	@Input() holdDateEnd: Date;

	@Input() holdExpiredDateEnd: Date;
	@Input() holdExpiredDateStart: Date;

	@Input() cancelDateStart: Date;
	@Input() cancelDateEnd: Date;

	@Input() checkInDateStart: Date;
	@Input() checkInDateEnd: Date;

	@Input() checkOutDateStart: Date;
	@Input() checkOutDateEnd: Date;

	//This is used to search saleDate, cancelDate, holdDate and holdExpiredDate
	@Input() filterDateStart: Date;
	@Input() filterDateEnd: Date;

	@Input() futureGuestDate: Date;

	@Input() saleYear: Date;

	@Input() hideTitle = true;

	@ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;
	@ViewChild('filterDateEndCal') public filterDateEndCalender: Calendar;
	@ViewChild('saleDateEndCal') public saleDateEndCalender: Calendar;

	selectedLocationIds: any = [];
	selectedShortTermRentalIds: any = [];
	ownerProfileSelectedShortTermRentalIds: any = [];
	selectedYielMaxPropertyIds: any = [];
	selectedYielMaxDevelopments: any = [];
	selectedDevelopmentIds: any = [];
	selectedRateBucketIds: any = [];
	selectedYielMaxRateBucketIds: any = [];
	selectedBedrooms: any = [];
	selectedSleeps: any = [];
	selectedListingTypes: any = [];
	selectedReservationStatus: any = [];
	selectedReportType: any = [];
	selectedReportName: any = [];
	selectedCancelDateStart: any;
	selectedCancelDateEnd: any;
	selectedFilterDateStart: any;
	selectedFilterDateEnd: any;
	selectedHoldExpiredDateStart: any;
	selectedHoldExpiredDateEnd: any;
	selectedHoldDateStart: any;
	selectedHoldDateEnd: any;
	selectedCheckInDateStart: any;
	selectedCheckInDateEnd: any;
	selectedCheckOutDateStart: any;
	selectedCheckOutDateEnd: any;
	selectedFutureGuestDate: any;
	states: any[];

	selectedViews: any = [];
	selectedSeasons: any = [];
	selectedPropertyRanks: any = [];
	selectedNumNts: any = [];
	selectedReferralSources: any = [];
	selectedResTypes: any = [];
	selectListingStatuses: any = [];
	selectOwnerLeadListingStatuses: any = [];
	selectOwnerLeadSubAdrState: any = [];
	selectedStartDate: any;
	selectedEndDate: any;
	selectedSaleDateStart: any;
	selectedSaleDateEnd: any;
	selectedSaleYear: any;
	rateBuckets: any;
	yielMaxRateBuckets: any;
	shortTermRentals: any;
	yielMaxProperties: any;
	yielMaxDevelopments: any;
	developments: any;
	minToDate: any = new Date();
	minFilterEndDate: any = new Date();
	/** Minimum selectable date for Sale Date End — updated whenever Sale Date Start changes. */
	minSaleDateEnd: any = null;

	bedrooms = [
		{ id: 0, name: 'Studio' },
		{ id: 1, name: '1 Bd' },
		{ id: 2, name: '2 Bd' },
		{ id: 3, name: '3 Bd' },
		{ id: 4, name: '4 Bd' },
		{ id: 5, name: '5 Bd' },
		{ id: 6, name: '6 Bd' },
		{ id: 7, name: '7 Bd' },
		{ id: 8, name: '8 Bd' },
		{ id: 9, name: '9 Bd' },
		{ id: 10, name: '10 Bd' },
	];

	sleeps = [
		{ id: 1, name: '1 Sleep' },
		{ id: 2, name: '2 Sleep' },
		{ id: 3, name: '3 Sleep' },
		{ id: 4, name: '4 Sleep' },
		{ id: 5, name: '5 Sleep' },
		{ id: 6, name: '6 Sleep' },
		{ id: 7, name: '7 Sleep' },
		{ id: 8, name: '8 Sleep' },
		{ id: 9, name: '9 Sleep' },
		{ id: 10, name: '10 Sleep' },
		{ id: 11, name: '11 Sleep' },
		{ id: 12, name: '12 Sleep' },
		{ id: 13, name: '13 Sleep' },
		{ id: 14, name: '14 Sleep' },
		{ id: 15, name: '15 Sleep' },
		{ id: 16, name: '16 Sleep' },
		{ id: 17, name: '17 Sleep' },
		{ id: 18, name: '18 Sleep' },
		{ id: 19, name: '19 Sleep' },
		{ id: 20, name: '20 Sleep' },
	];

	listingType = [
		{ value: 1, name: 'Standalone Only' },
		{ value: 2, name: 'Composite Only' },
	];

	viewTypes = [
		{ value: 'NV', name: 'No View' },
		{ value: 'GGV', name: 'Garden View' },
		{ value: 'RV', name: 'Resort View' },
		{ value: 'BF', name: 'Beach Front' },
		{ value: 'BV', name: 'Beach View' },
		{ value: 'BP', name: 'Beach View Partial' },
		{ value: 'OF', name: 'Ocean Front' },
		{ value: 'OV', name: 'Ocean View' },
		{ value: 'OP', name: 'Ocean View Partial' },
		{ value: 'PK', name: 'Ocean View Peakaboo' },
		{ value: 'LF', name: 'Lake Front' },
		{ value: 'LV', name: 'Lake View' },
		{ value: 'LVP', name: 'Lake View Partial' },
		{ value: 'MV', name: 'Mountain' },
		{ value: 'PMV', name: 'Partial Mountain' },
		{ value: 'TRE', name: 'Tree' },
		{ value: 'VAL', name: 'Valley' },
		{ value: 'STR', name: 'Street' },
		{ value: 'HIL', name: 'Hill' },
		{ value: 'CIT', name: 'City' },
		{ value: 'GF', name: 'Golf Course Front' },
		{ value: 'GV', name: 'Golf Course View' },
		{ value: 'GP', name: 'Golf Course View Partial' },
		{ value: 'SK', name: 'Ski In Out' }
	];

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Archived' }
	];

	seasons = [
		{ id: 1, name: 'Low' },
		{ id: 2, name: 'Low-Med' },
		{ id: 3, name: 'Medimum' },
		{ id: 4, name: 'Med-High' },
		{ id: 5, name: 'Peak' },
	];

	propertyRanks = [
		{ value: 1, name: 'Platinum' },
		{ value: 2, name: 'Gold' },
		{ value: 3, name: 'Blue' }
	];

	numNts = [
		{ id: 1, name: '1' },
		{ id: 2, name: '2' },
		{ id: 3, name: '3' },
		{ id: 4, name: '4' },
		{ id: 5, name: '5' },
		{ id: 6, name: '6' },
		{ id: 7, name: '7' },
		{ id: 8, name: '8' },
		{ id: 9, name: '9' },
		{ id: 10, name: '10' },
		{ id: 11, name: '11' },
		{ id: 12, name: '12' },
		{ id: 13, name: '13' },
		{ id: 14, name: '14' },
		{ id: 15, name: '15' },
		{ id: 16, name: '16' },
		{ id: 17, name: '17' },
		{ id: 18, name: '18' },
		{ id: 19, name: '19' },
		{ id: 20, name: '20' },
		{ id: 21, name: '21' },
		{ id: 22, name: '22' },
		{ id: 23, name: '23' },
		{ id: 24, name: '24' },
		{ id: 25, name: '25' },
		{ id: 26, name: '26' },
		{ id: 27, name: '27' },
		{ id: 28, name: '28' },
		{ id: 29, name: '29' },
		{ id: 30, name: '30' },
	];

	resTypes = [
		{ name: 'Guest', value: 'OP'},
		{ name: 'Maintenance', value: 'NA'},
		{ name: 'Owner Occ', value: 'OO'},
		{ name: 'Owner Guest', value: 'OG'}
	];

	referralSources: any[];


	// forms
	form1: UntypedFormGroup;
	form2: UntypedFormGroup;
	formLoading = false;
	formReady = false;
	formToSubmit: any;
	form2ToSubmit: any;
	locations: any[];
	ownerProfileListingStatuses: { name: string; value: string; }[];
	tagName: any[];
	guestMasterDevelopmentList: any[];
	guestMasterSubjAdrCityList: any[];
	guestMasterSubAdrIslandList: any[];

	ownerLeadProfileCityList: any[];
	ownerLeadProfileSubjAdrStateList: any[];
	ownerLeadProfileSubAdrIslandList: any[];

	ownerProfileListingStatusList: any[];
	ownerProfileSubjAdrStateList: any[];
	ownerProfileSubAdrIslandList: any[];
	ownerProfileDevelopmentList: any[];

	realtorProfileSubjAdrStateList: any[];
	realtorProfileSubAdrIslandList: any[];

	propertyLeadProfileDevelopmentList: any[];
	propertyLeadProfileSubjAdrStateList: any[];
	propertyLeadProfileSubAdrIslandList: any[];

	jobLevelList: any[];
	jobCategoryList: any[];
	employeeListingList: any[];

	contanctSubjAdrStateList: any[];
	contactSubAdrIslandList: any[];
	ownerLeadSubAdrIsland: any[];
	ownerLeadSubAdrCity: any[];
	propertyLeadListingStatus: any[];
	propertyLeadSubAdrIsland: any[];
	propertyLeadSubjAdrState: any[];
	propertyLeadSubjAdrDevelopmentName: any[];
	employeeLeadListingStatus: any[];
	employeeLocationIdList: any[];
	jobLevel: any[];
	jobCategories: any[];
	ownerListingStatus: any[];
	ownerProfileSubAdrIsland: any[];
	ownerProfileSubjAdrState: any[];
	ownerProfileSubjAdrDevelopmentName: any[];
	ownerProfileTags: any[];
	ownerLeadProfileTags: any[];
	realtorListingStatus: any[];
	guestProfileTags: any[];
	guestMasterProfileTags: any[];
	propertyLeadProfileTags: any[];
	realtorProfileTags: any[];
	contactTags: any[];
	realtorAdrIsland: any[];
	realtorAdrState: any[];
	contactAdrIsland: any[];
	contactAdrState: any[];
	guestMasterAdrIsland: any[];
	guestMasterAdrDevelopmentName: any[];
	guestSubjAdrCity: any[];
	guestMasterAdrCity: any[];
	tagSuggestions: any = [];
	tagAddModalDialogRef: any;
	tagType: any;


	constructor(private reportService: ReportService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private rateBucketService: RateBucketService,
		public formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		private constantService: ConstantService,
		private OwnerLeadProfileService: OwnerLeadProfileService,
		private TagService: TagService,
		private developmentService: DevelopmentService,
		private propertyLeadService: PropertyLeadProfileService,
		private ownerProfileService: OwnerProfileService,
		private propertyService: PropertyService,
		private realtorProfileService: RealtorProfileService,
		private employeeProfileService: EmployeeProfileService,
		private reservationService: ReservationService,
		private contactService: ContactService,
		@Optional() @Inject(MAT_DIALOG_DATA) data: any) {
		if (data) {
			this.searchLabel = data.searchLabel,
				this.applyTagLabel = data.applyTagLabel;
			this.removeTagLabel = data.removeTagLabel;
			this.formTitle = data.formTitle,
				this.showLocations = data.showLocations;
			this.showShortTermRentals = data.showShortTermRentals;
			this.showYieldMaxProperties = data.showYieldMaxProperties;
			this.showYieldMaxDevelopments = data.showYieldMaxDevelopments;
			this.showViewTypes = data.showViewTypes;
			this.showDevelopments = data.showDevelopments;
			this.showRateBuckets = data.showRateBuckets;
			this.showYieldMaxRateBuckets = data.showYieldMaxRateBuckets;
			this.showBedrooms = data.showBedrooms;
			this.showSleeps = data.showSleeps;
			this.showListingTypes = data.showListingTypes;
			this.showSeasons = data.showSeasons;
			this.showPropertyRanks = data.showPropertyRanks;
			this.showNumNts = data.showNumNts;
			this.showReferralSources = data.showReferralSources;
			this.showResTypes = data.showResTypes;
			this.showStartDate = data.showStartDate;
			this.showEndDate = data.showEndDate;
			this.showSearchButton = data.showSearchButton;
			this.showApplyTagButton = data.showApplyTagButton;
			this.showRemoveTagButton = data.showRemoveTagButton;
			this.showSearchButtonForm2 = data.showSearchButtonForm2;
		}
		this.locations = this.constantService.locations;
		this.ownerProfileListingStatuses = this.ownerProfileService.listingStatuses;
		var tags = this.TagService.findAll();
		this.states = this.constantService.states;
		this.employeeListingList = this.employeeProfileService.listingStatuses;
		this.jobCategoryList = this.employeeProfileService.jobCategories;
		this.jobLevelList = this.employeeProfileService.jobLevels;
		this.referralSources = this.reservationService.referralSources;
		if(this.guestMasterProfile)
		{
			this.developmentService.getFilterData()
				.subscribe(
					res => {
						this.guestMasterDevelopmentList = res.data.filterData.addressDevelopmentNames;
						this.guestMasterSubAdrIslandList = res.data.filterData.addressIslands;
						this.guestMasterSubjAdrCityList = res.data.filterData.addressCities;
	
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		}

		if(this.ownerLeadProfile)
		{
			this.OwnerLeadProfileService.getFilterData()
				.subscribe(
					res => {
						this.ownerLeadProfileSubjAdrStateList = res.data.filterData.addressStates;
						this.ownerLeadProfileSubAdrIslandList = res.data.filterData.addressIslands;
						this.ownerLeadProfileCityList = res.data.filterData.addressCities;
	
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		}

		if(this.propertyLeadProfile)
		{
			this.propertyLeadService.getFilterData()
				.subscribe(
					res => {
						this.propertyLeadProfileSubjAdrStateList = res.data.filterData.addressStates;
						this.propertyLeadProfileSubAdrIslandList = res.data.filterData.addressIslands;
						this.propertyLeadProfileDevelopmentList = res.data.filterData.addressDevelopmentNames;
	
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		}

		if(this.ownerProfile)
		{
			this.ownerProfileService.getFilterData()
				.subscribe(
					res => {
						this.ownerProfileListingStatusList = res.data.filterData.listingStatus;
	
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });

					this.propertyService.getFilterData()
						.subscribe(
							res => {
								this.ownerProfileSubjAdrStateList = res.data.filterData.addressStates;
								this.ownerProfileSubAdrIslandList = res.data.filterData.addressIslands;
								this.ownerProfileDevelopmentList = res.data.filterData.addressDevelopmentNames;
			
							},
							err => {
								console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							},
							() => { });
		}

		if(this.realtorProfile)
		{
			this.realtorProfileService.getFilterData()
				.subscribe(
					res => {
						this.realtorProfileSubjAdrStateList = res.data.filterData.addressStates;
						this.realtorProfileSubAdrIslandList = res.data.filterData.addressIslands;
	
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		}
		if(this.contacts)
		{
			this.contactService.getFilterData()
				.subscribe(
					res => {
						this.contanctSubjAdrStateList = res.data.filterData.addressStates;
						this.contactSubAdrIslandList = res.data.filterData.addressIslands;

					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		}

		// Initialize form groups early so template bindings don't throw before ngOnInit
		// (formBuild() / form2Build() in ngOnInit will replace these with the real forms)
		this.form1 = this.formBuilder.group({});
		this.form2 = this.formBuilder.group({});
	}

	ngAfterViewInit(): void {
		this.patchDates();
		//Call search method to display the report records with default dates without user interaction
		if (this.displayRecordsOnPageLoad) {
			this.searchClick();
			this.searchClickForForm2();
		}
	}


	ngOnInit(): void {
		if(this.showShortTermRentals)
		{
			this.loadShortTermRentals();
		}
		if(this.showDevelopments)
		{
			this.loadDevelopments();
		}
		if(this.showRateBuckets)
		{
			this.loadRateBuckets();
		}
		this.formBuild();
		this.form2Build();
		this.formReady = true;
		this.patchDates();
		if(this.showYieldMaxProperties || this.showYieldMaxRateBuckets) {
			this.loadPropertiesYieldMax();
		}
		if(this.showYieldMaxDevelopments) {
			this.loadDevelopmentsYieldMax();
		}
		if(this.showYieldMaxRateBuckets) {
			this.loadRateBucketsYieldMax();
		}

		// clear the presets, if any.
		if (this.reset) {
			this.form1.reset();
			// Re-apply date defaults after reset — form1.reset() clears values set by the earlier
			// patchDates() call, so we must re-patch here to preserve [dateRange] defaults.
			this.patchDates();
		}
		// Apply any pre-set LOS nights AFTER the reset so they aren't wiped.
		// Must come after form1.reset() because the tape chart passes [reset]=true.
		if (this.preSetNumNts?.length) {
			this.form1.patchValue({ formNumNts: this.preSetNumNts });
			this.formToSubmit = this.formToSubmit || {};
			this.formToSubmit.numNtsList = [...this.preSetNumNts];
		}
		if (this.showExcludeFutureGuests) {
			this.form1.controls['excludeFutureGuests'].setValue(true);
			this.form1.controls['includeRegisteredGuest'].setValue(true);
			this.form1.controls['includeProspectGuest'].setValue(false);
		}
    if (this.showExcludeUnsubscribers) {
      this.form1.controls['excludeUnsubscribers'].setValue(true);
    }
    if (this.showExcludeOwnerProfiles) {
      this.form1.controls['excludeOwnerProfiles'].setValue(true);
    }
	// if(this.showResTypes)
	// {
	// 	this.form1.patchValue({
	// 		formResTypes: [this.resTypes.find(item => item.value === 'OP')],
	// 	});
	// }

	if(this.showListingTypes)
		{
			const standalone = this.listingType.find(item => item.value === 1);
			if (standalone != null) {
				this.form1.patchValue({
					formListingType: [standalone.value],
				});
			}
		}

	}

	ngOnChanges(changes: SimpleChanges): void {
		// Pre-populate the LOS multiselect when the parent passes a default night count (e.g. from inbox flexNumNights)
		if (changes['preSetNumNts'] && this.form1 && this.preSetNumNts?.length) {
			this.form1.patchValue({ formNumNts: this.preSetNumNts });
			this.formToSubmit = this.formToSubmit || {};
			this.formToSubmit.numNtsList = [...this.preSetNumNts];
		}
		//Show default value on YieldMax bulk edit component based on tape chart selection
		if(this.yieldMaxSelectedProperty)
		{
			let formYielMaxPropertyIds = [];
			if(this.yielMaxProperties)
			{
				this.yielMaxProperties.forEach(property => {
					if(property.propertyId == this.yieldMaxSelectedProperty)
					{
						let selectedYielMaxPropertyRateBucketIds = [];
						formYielMaxPropertyIds.push(property.propertyId);
						selectedYielMaxPropertyRateBucketIds.push(property.rateBucketId);
						if(!this.formToSubmit)
						{
							this.formToSubmit = {};
						}
						this.formToSubmit.yielMaxPropertyRateBucketIdList = selectedYielMaxPropertyRateBucketIds;
						this.form1.patchValue({
							formYielMaxPropertyIds: formYielMaxPropertyIds
						});
						return;
					}
				});
			}
		}
		if(this.yieldMaxSelectedStartDate && this.form1)
		{
			this.form1.patchValue({
				formStartDate: new Date(this.yieldMaxSelectedStartDate)
			});
			if (!this.formToSubmit) { this.formToSubmit = {}; }
			this.formToSubmit.startDate = this.yieldMaxSelectedStartDate;
			this.minToDate = this.form1.get('formStartDate').value;
		}
		if(this.form1 && this.endDate && this.startDate && this.startDate <= this.endDate)
		{
			this.form1.patchValue({
				formEndDate: this.endDate
			});
			if (!this.formToSubmit) { this.formToSubmit = {}; }
			this.formToSubmit.endDate = this.endDate;
		}
		if(this.form1 && this.startDate)
		{
			this.form1.patchValue({
				formStartDate: this.startDate
			});
			if (!this.formToSubmit) { this.formToSubmit = {}; }
			this.formToSubmit.startDate = this.startDate;
			this.minToDate = this.form1.get('formStartDate').value;
			// If To date is null or previous than start date then auto focus on To date calender
			if(!this.form1.get('formStartDate').value || !this.form1.get('formEndDate').value 
				|| this.form1.get('formStartDate').value > this.form1.get('formEndDate').value)
			{
				this.form1.patchValue({
					formEndDate: null
				});
	
				window.setTimeout(() => {
					this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
				}, 1);
			}
		}
		//call back to bulk update component
		this.doChangeCB.emit(this.formToSubmit);
	}

	patchDates() {
		if (!this.showListingStatus && !this.isBulkEditing && !this.showBlankStartAndEndDate) {
			if (!this.startDate && this.showStartDate) {
				let startDate = new Date();
				this.startDate = startDate;
				console.log('this.startDate ' + this.startDate);
			}
			if (!this.endDate && this.showEndDate) {
				if(this.showResMasReportName)
				{
					let endDate = new Date();
					endDate.setDate(endDate.getDate() + 1);
					this.endDate = endDate;
					console.log('this.endDate ' + this.endDate);
				}
				else
				{
					let endDate = new Date();
					endDate.setDate(endDate.getDate() + 60);
					this.endDate = endDate;
					console.log('this.endDate ' + this.endDate);
				}
			}
		}

		if (!this.saleDateEnd && this.showSaleDateEnd && !this.showResMasReportName && (!this.showFilterDateStart || this.disableFilterDateDefault)) {
			let saleDateEnd = new Date();
			saleDateEnd.setUTCDate(saleDateEnd.getDate() - 1);
			this.saleDateEnd = saleDateEnd;
			console.log('this.saleDateEnd ' + this.saleDateEnd);
		}
		if (!this.checkOutDateEnd && this.checkOutDateEnd) {
			let checkOutDateEnd = new Date();
			checkOutDateEnd.setUTCDate(checkOutDateEnd.getDate());
			this.checkOutDateEnd = checkOutDateEnd;
			console.log('this.checkOutDateEnd ' + this.checkOutDateEnd);
		}

		if (!this.checkOutDateStart && this.checkOutDateStart) {
			let checkOutDateStart = new Date();
			checkOutDateStart.setUTCDate(checkOutDateStart.getDate());
			this.checkOutDateStart = checkOutDateStart;
			console.log('this.checkOutDateStart ' + this.checkOutDateStart);
		}

		if (!this.checkInDateEnd && this.checkInDateEnd) {
			let checkInDateEnd = new Date();
			checkInDateEnd.setUTCDate(checkInDateEnd.getDate());
			this.checkInDateEnd = checkInDateEnd;
			console.log('this.checkInDateEnd ' + this.checkInDateEnd);
		}

		if (!this.checkInDateStart && this.checkInDateStart) {
			let checkInDateStart = new Date();
			checkInDateStart.setUTCDate(checkInDateStart.getDate());
			this.checkInDateStart = checkInDateStart;
			console.log('this.checkInDateStart ' + this.checkInDateStart);
		}

		if (!this.holdDateEnd && this.holdDateEnd) {
			let holdDateEnd = new Date();
			holdDateEnd.setUTCDate(holdDateEnd.getDate());
			this.holdDateEnd = holdDateEnd;
			console.log('this.holdDateEnd ' + this.holdDateEnd);
		}

		if (!this.holdDateStart && this.holdDateStart) {
			let holdDateStart = new Date();
			holdDateStart.setUTCDate(holdDateStart.getDate());
			this.holdDateStart = holdDateStart;
			console.log('this.holdDateStart ' + this.holdDateStart);
		}

		if (!this.holdExpiredDateStart && this.holdExpiredDateStart) {
			let holdExpiredDateStart = new Date();
			holdExpiredDateStart.setUTCDate(holdExpiredDateStart.getDate());
			this.holdExpiredDateStart = holdExpiredDateStart;
			console.log('this.holdExpiredDateStart ' + this.holdExpiredDateStart);
		}

		if (!this.holdExpiredDateEnd && this.holdExpiredDateEnd) {
			let holdExpiredDateEnd = new Date();
			holdExpiredDateEnd.setUTCDate(holdExpiredDateEnd.getDate());
			this.holdDateEnd = holdExpiredDateEnd;
			console.log('this.holdExpiredDateEnd ' + this.holdExpiredDateEnd);
		}

		if (!this.cancelDateStart && this.cancelDateStart) {
			let cancelDateStart = new Date();
			cancelDateStart.setUTCDate(cancelDateStart.getDate());
			this.cancelDateStart = cancelDateStart;
			console.log('this.cancelDateStart ' + this.cancelDateStart);
		}

		if (!this.cancelDateEnd && this.cancelDateEnd) {
			let cancelDateEnd = new Date();
			cancelDateEnd.setUTCDate(cancelDateEnd.getDate());
			this.holdDateEnd = cancelDateEnd;
			console.log('this.cancelDateEnd ' + this.cancelDateEnd);
		}

		if (!this.filterDateEnd && this.filterDateEnd) {
			let filterDateEnd = new Date();
			filterDateEnd.setUTCDate(filterDateEnd.getDate());
			this.holdDateEnd = filterDateEnd;
			console.log('this.filterDateEnd ' + this.filterDateEnd);
		}

		if (!this.futureGuestDate && this.futureGuestDate) {
			let futureGuestDate = new Date();
			futureGuestDate.setUTCDate(futureGuestDate.getDate());
			this.futureGuestDate = futureGuestDate;
			console.log('this.futureGuestDate ' + this.futureGuestDate);
		}

		if (!this.saleYear && this.showSaleYear) {
			let saleYear = new Date();
			this.saleYear = saleYear;
			console.log('this.saleYear ' + this.saleYear);
		}


		if (!this.saleDateStart && this.showSaleDateStart && !this.showResMasReportName && (!this.showFilterDateStart || this.disableFilterDateDefault)) {
			let saleDateStart = new Date();
			saleDateStart.setUTCDate(saleDateStart.getDate() - 1);
			this.saleDateStart = saleDateStart;
			console.log('this.saleDateStart ' + this.saleDateStart);
		}
		if (!this.filterDateStart && this.showFilterDateStart && !this.showResMasReportName && !this.disableFilterDateDefault) {
			let filterDateStart = new Date();
			filterDateStart.setUTCDate(filterDateStart.getDate() - 1);
			this.filterDateStart = filterDateStart;
			// Allow end date to equal the auto-defaulted start date (yesterday).
			this.minFilterEndDate = filterDateStart;
		}
		if (!this.filterDateEnd && this.showFilterDateEnd && !this.showResMasReportName && !this.disableFilterDateDefault) {
			let filterDateEnd = new Date();
			filterDateEnd.setUTCDate(filterDateEnd.getDate() - 1);
			this.filterDateEnd = filterDateEnd;
		}

		//If custom date range is set then update dates as per user input
		if (this.showCustomDateRange) {
			let todayDate = new Date();
			if (this.dateRange && this.dateRange == 'year') {
				if (this.showStartDate) {
					// let startDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1); // 1st date of current month
					let startDate = new Date(todayDate.getFullYear(), 0, 1); // 1st date of Jan month
					this.startDate = startDate;
				}
				if (this.showEndDate) {
					// let endDate = new Date((todayDate.getFullYear() + 1), (todayDate.getMonth()), 1); // start date plus one year
					let endDate = new Date((todayDate.getFullYear()), 11, 31); // 31st Dec
					// endDate.setDate(endDate.getDate() - 1);
					this.endDate = endDate;
				}
			}
			if (this.dateRange && this.dateRange == 'month') {
				if (this.dateRangeNumber && this.dateRangeNumber > 0) {
					if (this.showStartDate) {
						let startDate = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1); // 1st date of current month
						this.startDate = startDate;
					}
					if (this.showEndDate) {
						let endDate = new Date((todayDate.getFullYear()), (todayDate.getMonth() + this.dateRangeNumber), 1); // start date plus one year
						endDate.setDate(endDate.getDate() - 1);
						this.endDate = endDate;
					}
				}
			}
			if (this.dateRange && this.dateRange == 'yearFromToday') {
				if (this.showStartDate) {
					this.startDate = todayDate // today's date
				}
				if (this.showEndDate) {
					let endDate = new Date((todayDate.getFullYear() + 1), (todayDate.getMonth()), todayDate.getDate()); // start date plus one year
					endDate.setDate(endDate.getDate() - 1);
					this.endDate = endDate;
				}
			}
			if (this.dateRange && this.dateRange == 'pastYearFromToday') {
				if (this.showStartDate) {
					let startDate = new Date((todayDate.getFullYear() - 1), (todayDate.getMonth()), todayDate.getDate()); // start date minus one year
					startDate.setDate(startDate.getDate() - 1);
					this.startDate = startDate;
				}
				if (this.showEndDate) {
					this.endDate = todayDate; // today's date
					if(this.showCustomDateRange) {
						this.minToDate = this.startDate;
					}
				}
			}
			if (this.dateRange && this.dateRange == 'yearToDate') {
				if (this.showStartDate) {
					let startDate = new Date(todayDate.getFullYear(), 0, 1); // 1st date of Jan month
					this.startDate = startDate;
				}
				if (this.showEndDate) {
					this.endDate = todayDate; // today's date
					if(this.showCustomDateRange) {
						this.minToDate = this.startDate;
					}
				}
			}
		}

		if (this.form1) {
			if (this.startDate) {
				this.form1.patchValue({
					formStartDate: this.startDate
				});
				if (this.showEndDate) {
					this.minToDate = this.form1.get('formStartDate').value;
				}
			}
			if (this.endDate) {
				this.form1.patchValue({
					formEndDate: this.endDate
				});
			}
			if (this.yieldMaxSelectedStartDate) {
				this.form1.patchValue({
					formStartDate: new Date(this.yieldMaxSelectedStartDate)
				});
				if (!this.yieldMaxSelectedEndDate) {
					this.minToDate = this.form1.get('formStartDate').value;
				}
			}
			if (this.yieldMaxSelectedEndDate) {
				this.form1.patchValue({
					formEndDate: new Date(this.yieldMaxSelectedEndDate)
				});
			}
			if (this.saleDateStart) {
				this.form1.patchValue({
					formSaleDateStart: this.saleDateStart
				});
				// Seed the minimum end-date so it starts at (or after) the
				// pre-populated start date — same pattern as minFilterEndDate.
				this.minSaleDateEnd = this.saleDateStart;
			}
			if (this.saleDateEnd) {
				this.form1.patchValue({
					formSaleDateEnd: this.saleDateEnd
				});
			}
			if (this.filterDateStart) {
				this.form1.patchValue({
					formFilterDateStart: this.filterDateStart
				});
			}
			if (this.filterDateEnd) {
				this.form1.patchValue({
					formFilterDateEnd: this.filterDateEnd
				});
			}
		}

		if (this.form2) {
			if (this.saleYear) {
				this.form2.patchValue({
					formSaleYear: this.saleYear
				});
			}
		}
	}


	/*
	 *
	 *SEARCH FORM - TO PUT INTO COMPONENT
	 *
	 */

	searchClick() {
		console.log(this.form1.value);
		this.buildSearchForm();
		console.log(JSON.stringify(this.formToSubmit));
		this.doSearchCB.emit(this.formToSubmit);
		return;
	}

	onChange(field?) {
		console.log(this.form1.value);
		this.buildSearchForm(field);
		console.log(JSON.stringify(this.formToSubmit));
		this.doChangeCB.emit(this.formToSubmit);
		return;
	}

	tagApplyButtonClick() {
		console.log(this.form1.value);
		this.buildSearchForm();
		console.log(JSON.stringify(this.formToSubmit));
		this.formToSubmit.tagAction = 'add';
		this.doApplyTagCB.emit(this.formToSubmit);
		return;
	}

	tagRemoveButtonClick() {
		console.log(this.form1.value);
		this.buildSearchForm();
		console.log(JSON.stringify(this.formToSubmit));
		this.formToSubmit.tagAction = 'remove';
		this.doRemoveTagCB.emit(this.formToSubmit);
		return;
	}

	searchClickForForm2() {
		console.log(this.form2.value);
		this.buildSearchForm2();
		console.log(JSON.stringify(this.form2ToSubmit));
		this.doSearchCBForm2.emit(this.form2ToSubmit);
		return;
	}


	formBuild() {

		this.form1 = this.formBuilder.group({

			formLocationIds: [],
			formShortTermRentalIds: [],
			formYielMaxPropertyIds: [],
			formYielMaxDevelopmentIds: [],
			formDevelopmentIds: [],
			formRateBucketIds: [],
			formYielMaxRateBucketIds: [],
			formBedrooms: [],
			formSleeps: [],
			formListingType: [],
			formViews: [],
			formSeasons: [],
			formPropertyRank:[],
			formNumNts:[],
			formReferralSources:[],
			formResTypes: [],
			formStartDate: [],
			formEndDate: [],
			formSaleDateStart: [],
			formSaleDateEnd: [],
			formSaleYear: [],
			listingStatus: [],
			excludeFutureGuests: [],
			excludeUnsubscribers: [],
			excludeOwnerProfiles: [],
			includeRegisteredGuest: [],
			includeProspectGuest: [],
			formReservationStatus: [],
			formResMasterReportType: [],
			formResMasterReportName: [],
			formCancelDateEnd: [],
			formCancelDateStart: [],
			formFilterDateEnd: [],
			formFilterDateStart: [],
			formHoldExpiredDateEnd: [],
			formHoldExpiredDateStart: [],
			formHoldDateEnd: [],
			formHoldDateStart: [],
			formCheckInDateEnd: [],
			formCheckInDateStart: [],
			formCheckOutDateEnd: [],
			formCheckOutDateStart: [],
			formFutureGuestDate: [],
			ownerLeadListingStatus: [],
			subAdrIsland: [],
			subjAdrState: [],
			ownerLeadSubjAdrState: [],
			ownerLeadSubAdrIsland: [],
			ownerLeadSubAdrCity: [],
			propertyLeadListingStatus: [],
			propertyLeadSubAdrIsland: [],
			propertyLeadSubjAdrState: [],
			propertyLeadSubjAdrDevelopmentName: [],
			employeeLeadListingStatus: [],
			employeeLocationIdList: [],
			jobLevel: [],
			jobCategories: [],
			ownerListingStatus: [],
			ownerProfileSubAdrIsland: [],
			ownerProfileSubjAdrState: [],
			ownerProfileSubjAdrDevelopmentName: [],
			ownerProfileShortTermRental: [],
			ownerProfileTags: [],
			ownerLeadProfileTags: [],
			guestProfileTags: [],
			guestMasterProfileTags: [],
			propertyLeadProfileTags: [],
			realtorProfileTags: [],
			contactTags: [],
			realtorListingStatus: [],
			realtorAdrIsland: [],
			realtorAdrState: [],
			contactAdrIsland: [],
			contactAdrState: [],
      contactEmail: [],
      reservationId: [],
      contactFirstName: [],
      contactLastName: [],
      contactsTags: [],
			guestMasterAdrIsland: [],
			guestMasterAdrCity: [],
			guestMasterAdrDevelopmentName: [],
			applyTagIds: [],

		});
		this.patchDates();
	}

	form2Build() {
		this.form2 = this.formBuilder.group({
			formSaleYear: [],
		});
		this.patchDates();
	}



	buildSearchForm(field?) {
		this.formToSubmit = {};

		// locationIds
		this.selectedLocationIds = [];
		if (this.form1.get('formLocationIds').value) {
			this.form1.get('formLocationIds').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.locationId : element;
				this.selectedLocationIds.push(id);
			});
			this.formToSubmit.locationIdList = this.selectedLocationIds;
		}


		// developmentIds
		this.selectedDevelopmentIds = [];
		if (this.form1.get('formDevelopmentIds').value) {
			this.form1.get('formDevelopmentIds').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.developmentId : element;
				this.selectedDevelopmentIds.push(id);
			});
			this.formToSubmit.developmentIdList = this.selectedDevelopmentIds;
		}

		// shortTermRentalIds
		this.selectedShortTermRentalIds = [];
		if (this.form1.get('formShortTermRentalIds').value) {
			this.form1.get('formShortTermRentalIds').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.shortTermRentalId : element;
				this.selectedShortTermRentalIds.push(id);
			});
			this.formToSubmit.shortTermRentalIdList = this.selectedShortTermRentalIds;
		}

		// YielMaxPropertyIds
		this.selectedYielMaxPropertyIds = [];
		let selectedYielMaxPropertyRateBucketIds = [];
		if (this.form1.get('formYielMaxPropertyIds').value) {
			this.form1.get('formYielMaxPropertyIds').value.forEach(element => {
				const propertyId = element != null && typeof element === 'object' ? element.propertyId : element;
				this.selectedYielMaxPropertyIds.push(propertyId);
				const prop = this.yielMaxProperties?.find(p => p.propertyId == propertyId);
				if (prop) {
					selectedYielMaxPropertyRateBucketIds.push(prop.rateBucketId);
				}
			});
			this.formToSubmit.yielMaxPropertyIdList = this.selectedYielMaxPropertyIds;
			this.formToSubmit.yielMaxPropertyRateBucketIdList = selectedYielMaxPropertyRateBucketIds;
		}

		// LocationIds
		let selectedLocationRateBucketIdList = new Set();
		if (this.form1.get('formLocationIds').value) {
			this.form1.get('formLocationIds').value.forEach(element => {
				const locationId = element != null && typeof element === 'object' ? element.locationId : element;
				if(this.yielMaxProperties)
					{
						this.yielMaxProperties.forEach(property => {
							if(property.locationId == locationId)
							{
								selectedLocationRateBucketIdList.add(property.rateBucketId);
							}
						});
					}
			});
			this.formToSubmit.locationRateBucketIdList = selectedLocationRateBucketIdList
		}

		let formYielMaxPropertyIds = [];
		if(this.yieldMaxSelectedProperty && this.yielMaxProperties && !this.formToSubmit.yielMaxPropertyIdList?.length)
		{
			this.yielMaxProperties.forEach(property => {
				if(property.propertyId == this.yieldMaxSelectedProperty)
				{
					let selectedYielMaxPropertyRateBucketIds = [];
					formYielMaxPropertyIds.push(property.propertyId);
					selectedYielMaxPropertyRateBucketIds.push(property.rateBucketId);
					if(!this.formToSubmit)
					{
						this.formToSubmit = {};
					}
					this.formToSubmit.yielMaxPropertyRateBucketIdList = selectedYielMaxPropertyRateBucketIds;
					this.form1.patchValue({
						formYielMaxPropertyIds: formYielMaxPropertyIds
					});
					return;
				}
			});
		}

		// YielMaxDevelopmentIds
		this.selectedYielMaxDevelopments = [];
		if (this.form1.get('formYielMaxDevelopmentIds').value) {
			this.form1.get('formYielMaxDevelopmentIds').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedYielMaxDevelopments.push(v);
			});
			this.formToSubmit.yielMaxDevelopmentList = this.selectedYielMaxDevelopments;
		}


		// seasons
		this.selectedSeasons = [];
		if (this.form1.get('formSeasons').value) {
			this.form1.get('formSeasons').value.forEach(element => {
				this.selectedSeasons.push(element.id);
			});
			this.formToSubmit.seasonList = this.selectedSeasons;
		}

		// propertyRanks
		this.selectedPropertyRanks = [];
		if (this.form1.get('formPropertyRank').value) {
			this.form1.get('formPropertyRank').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedPropertyRanks.push(v);
			});
			this.formToSubmit.propertyRankList = this.selectedPropertyRanks;
		}

		// propertyRanks
		this.selectedNumNts = [];
		if (this.form1.get('formNumNts').value) {
			this.form1.get('formNumNts').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.id : element;
				this.selectedNumNts.push(id);
			});
			this.formToSubmit.numNtsList = this.selectedNumNts;
		}

		// ReferralSources
		this.selectedReferralSources = [];
		if (this.form1.get('formReferralSources').value) {
			this.form1.get('formReferralSources').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedReferralSources.push(v);
			});
			this.formToSubmit.referralSources = this.selectedReferralSources;
		}

		// ResTypes
		this.selectedResTypes = [];
		if (this.form1.get('formResTypes').value) {
			this.form1.get('formResTypes').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedResTypes.push(v);
			});
			this.formToSubmit.resTypes = this.selectedResTypes;
		}

		// bedrooms
		this.selectedBedrooms = [];
		if (this.form1.get('formBedrooms').value) {
			this.form1.get('formBedrooms').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.id : element;
				this.selectedBedrooms.push(id);
			});
			this.formToSubmit.bedroomList = this.selectedBedrooms;
		}

		// sleeps
		this.selectedSleeps = [];
		if (this.form1.get('formSleeps').value) {
			this.form1.get('formSleeps').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.id : element;
				this.selectedSleeps.push(id);
			});
			this.formToSubmit.sleepList = this.selectedSleeps;
		}

		// Listing Type
		this.selectedListingTypes = [];
		if (this.form1.get('formListingType').value) {
			this.form1.get('formListingType').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedListingTypes.push(v);
			});
			this.formToSubmit.listingTypeList = this.selectedListingTypes;
		}

		//reservationStatus
		this.selectedReservationStatus = [];
		if (this.form1.get('formReservationStatus').value) {
			this.form1.get('formReservationStatus').value.forEach(element => {
				this.selectedReservationStatus.push(element);
			});
			this.formToSubmit.reservationStatusList = this.selectedReservationStatus;
		}

		// reportType
		if (this.form1.get('formResMasterReportType').value) {
			this.selectedReportType = this.form1.get('formResMasterReportType').value;
			this.formToSubmit.reportType = this.selectedReportType;
		}

		// reportName
		if (this.form1.get('formResMasterReportName').value) {
			this.selectedReportName = this.form1.get('formResMasterReportName').value;
			this.formToSubmit.reportName = this.selectedReportName;
		}

		// CancelDateStart
		if (this.form1.get('formCancelDateStart').value) {
			this.selectedCancelDateStart = this.form1.get('formCancelDateStart').value;
			this.formToSubmit.cancelDateStart = this.selectedCancelDateStart;
		}

		// CancelDateStart
		if (this.form1.get('formCancelDateEnd').value) {
			this.selectedCancelDateEnd = this.form1.get('formCancelDateEnd').value;
			this.formToSubmit.cancelDateEnd = this.selectedCancelDateEnd;
		}

		// FilterDateStart
		if (this.form1.get('formFilterDateStart').value) {
			this.selectedFilterDateStart = this.form1.get('formFilterDateStart').value;
			this.formToSubmit.filterDateStart = this.selectedFilterDateStart;
		}

		// FilterDateStart
		if (this.form1.get('formFilterDateEnd').value) {
			this.selectedFilterDateEnd = this.form1.get('formFilterDateEnd').value;
			this.formToSubmit.filterDateEnd = this.selectedFilterDateEnd;
		}

		// CheckInDateStart
		if (this.form1.get('formCheckInDateStart').value) {
			this.selectedCheckInDateStart = this.form1.get('formCheckInDateStart').value;
			this.formToSubmit.checkInDateStart = this.selectedCheckInDateStart;
		}

		// CheckInDateEnd
		if (this.form1.get('formCheckInDateEnd').value) {
			this.selectedCheckInDateEnd = this.form1.get('formCheckInDateEnd').value;
			this.formToSubmit.checkInDateEnd = this.selectedCheckInDateEnd;
		}

		// CheckOutDateStart
		if (this.form1.get('formCheckOutDateStart').value) {
			this.selectedCheckOutDateStart = this.form1.get('formCheckOutDateStart').value;
			this.formToSubmit.checkOutDateStart = this.selectedCheckOutDateStart;
		}

		// CheckOutDateEnd
		if (this.form1.get('formCheckOutDateEnd').value) {
			this.selectedCheckOutDateEnd = this.form1.get('formCheckOutDateEnd').value;
			this.formToSubmit.checkOutDateEnd = this.selectedCheckOutDateEnd;
		}

		// HoldDateStart
		if (this.form1.get('formHoldDateStart').value) {
			this.selectedCheckInDateStart = this.form1.get('formHoldDateStart').value;
			this.formToSubmit.holdDateStart = this.selectedCheckInDateStart;
		}

		// HoldDateEnd
		if (this.form1.get('formHoldDateEnd').value) {
			this.selectedHoldDateEnd = this.form1.get('formHoldDateEnd').value;
			this.formToSubmit.holdDateEnd = this.selectedHoldDateEnd;
		}


		// HoldExpiredDateStart
		if (this.form1.get('formHoldExpiredDateStart').value) {
			this.selectedHoldExpiredDateStart = this.form1.get('formHoldExpiredDateStart').value;
			this.formToSubmit.holdExpiredDateStart = this.selectedHoldExpiredDateStart;
		}

		// HoldExpiredDateEnd
		if (this.form1.get('formHoldExpiredDateEnd').value) {
			this.selectedHoldExpiredDateEnd = this.form1.get('formHoldExpiredDateEnd').value;
			this.formToSubmit.holdExpiredDateEnd = this.selectedHoldExpiredDateEnd;
		}

		// FutureGuestDate
		if (this.form1.get('formFutureGuestDate').value) {
			this.selectedFutureGuestDate = this.form1.get('formFutureGuestDate').value;
			this.formToSubmit.futureGuestDate = this.selectedFutureGuestDate;
		}

		// views
		this.selectedViews = [];
		if (this.form1.get('formViews').value) {
			this.form1.get('formViews').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectedViews.push(v);
			});
			this.formToSubmit.viewList = this.selectedViews;
		}

		// listing statuses
		this.selectListingStatuses = [];
		if (this.form1.get('listingStatus').value) {
			this.form1.get('listingStatus').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectListingStatuses.push(v);
			});
			this.formToSubmit.listingStatus = this.selectListingStatuses;
		}

		// rateBucketIds
		this.selectedRateBucketIds = [];
		if (this.form1.get('formRateBucketIds').value) {
			this.form1.get('formRateBucketIds').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.rateBucketId : element;
				this.selectedRateBucketIds.push(id);
			});
			this.formToSubmit.rateBucketIdList = this.selectedRateBucketIds;
		}

		// rateBucketIds
		this.selectedYielMaxRateBucketIds = [];
		if (this.form1.get('formYielMaxRateBucketIds').value) {
			let selectedYielMaxPropertyIds = [];
			this.form1.get('formYielMaxRateBucketIds').value.forEach(element => {
				const rbId = element != null && typeof element === 'object' ? element.rateBucketId : element;
				this.selectedYielMaxRateBucketIds.push(rbId);
				if(this.yielMaxProperties)
					{
						this.yielMaxProperties.forEach(property => {
							if(property.rateBucketId == rbId)
								{
								selectedYielMaxPropertyIds.push(property.propertyId);
							}
						});
					}
			});
			this.formToSubmit.yielMaxRateBucketIdList = this.selectedYielMaxRateBucketIds;
			if (selectedYielMaxPropertyIds.length > 0) {
				this.formToSubmit.yielMaxPropertyIdList = selectedYielMaxPropertyIds;
			}
		}

		// start date
		if (this.form1.get('formStartDate').value) {
			this.selectedStartDate = this.form1.get('formStartDate').value;
			this.formToSubmit.startDate = this.selectedStartDate;
			this.minToDate = this.form1.get('formStartDate').value;
		}

		// end date
		if (this.form1.get('formEndDate').value) {
			this.selectedEndDate = this.form1.get('formEndDate').value;
			this.formToSubmit.endDate = this.selectedEndDate;
		}

		// 10-21-2024 Divy : If To date is null or previous than start date then auto focus on To date calender
		if(this.form1.get('formStartDate').value && field && field === 'fromDate')
		{
			this.form1.patchValue({
				formEndDate: null
			});

			window.setTimeout(() => {
				this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
			}, 1);
		}

		// sale start date
		if (this.form1.get('formSaleDateStart').value) {
			this.selectedSaleDateStart = this.form1.get('formSaleDateStart').value;
			this.formToSubmit.saleDateStart = this.selectedSaleDateStart;
		}

		// sale end date
		if (this.form1.get('formSaleDateEnd').value) {
			this.selectedSaleDateEnd = this.form1.get('formSaleDateEnd').value;
			this.formToSubmit.saleDateEnd = this.selectedSaleDateEnd;
		}
		if (this.form1.get('excludeFutureGuests').value) {
			this.selectedSaleDateEnd = this.form1.get('formSaleDateEnd').value;
			this.formToSubmit.excludeFutureGuests = true;
		}
		else {
			this.formToSubmit.excludeFutureGuests = false;
		}

    if (this.form1.get('excludeUnsubscribers').value) {
      this.formToSubmit.excludeUnsubscribers = true;
    }
    if (this.form1.get('excludeOwnerProfiles').value) {
      this.formToSubmit.excludeOwnerProfiles = true;
    }
		this.formToSubmit.guestProfileTags = this.guestProfileTags;

		// guest master profile
		this.guestMasterAdrIsland = [];
		if (this.form1.get('guestMasterAdrIsland').value) {
			this.form1.get('guestMasterAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.guestMasterAdrIsland.push(n);
			});
			this.formToSubmit.guestMasterAdrIsland = this.guestMasterAdrIsland;
		}
		this.guestMasterAdrCity = [];
		if (this.form1.get('guestMasterAdrCity').value) {
			this.form1.get('guestMasterAdrCity').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.guestMasterAdrCity.push(n);
			});
			this.formToSubmit.guestMasterAdrCity = this.guestMasterAdrCity;
		}
		this.guestMasterAdrDevelopmentName = [];
		if (this.form1.get('guestMasterAdrDevelopmentName').value) {
			this.form1.get('guestMasterAdrDevelopmentName').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.guestMasterAdrDevelopmentName.push(n);
			});
			this.formToSubmit.guestMasterAdrDevelopmentName = this.guestMasterAdrDevelopmentName;
		}
		this.formToSubmit.guestMasterProfileTags = this.guestMasterProfileTags;


		// owner lead
		this.selectOwnerLeadListingStatuses = [];
		if (this.form1.get('ownerLeadListingStatus').value) {
			this.form1.get('ownerLeadListingStatus').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.selectOwnerLeadListingStatuses.push(v);
			});
			this.formToSubmit.ownerLeadListingStatus = this.selectOwnerLeadListingStatuses;
		}
		this.selectOwnerLeadSubAdrState = [];
		if (this.form1.get('ownerLeadSubjAdrState').value) {
			this.form1.get('ownerLeadSubjAdrState').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.selectOwnerLeadSubAdrState.push(n);
			});
			this.formToSubmit.ownerLeadSubjAdrState = this.selectOwnerLeadSubAdrState;
		}
		this.ownerLeadSubAdrIsland = [];
		if (this.form1.get('ownerLeadSubAdrIsland').value) {
			this.form1.get('ownerLeadSubAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerLeadSubAdrIsland.push(n);
			});
			this.formToSubmit.ownerLeadSubAdrIsland = this.ownerLeadSubAdrIsland;
		}
		this.ownerLeadSubAdrCity = [];
		if (this.form1.get('ownerLeadSubAdrCity').value) {
			this.form1.get('ownerLeadSubAdrCity').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerLeadSubAdrCity.push(n);
			});
			this.formToSubmit.ownerLeadSubAdrCity = this.ownerLeadSubAdrCity;
		}
		this.formToSubmit.ownerLeadProfileTags = this.ownerLeadProfileTags;


		// property lead
		this.propertyLeadListingStatus = [];
		if (this.form1.get('propertyLeadListingStatus').value) {
			this.form1.get('propertyLeadListingStatus').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.propertyLeadListingStatus.push(v);
			});
			this.formToSubmit.propertyLeadListingStatus = this.propertyLeadListingStatus;
		}
		this.propertyLeadSubAdrIsland = [];
		if (this.form1.get('propertyLeadSubAdrIsland').value) {
			this.form1.get('propertyLeadSubAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.propertyLeadSubAdrIsland.push(n);
			});
			this.formToSubmit.propertyLeadSubAdrIsland = this.propertyLeadSubAdrIsland;
		}
		this.propertyLeadSubjAdrState = [];
		if (this.form1.get('propertyLeadSubjAdrState').value) {
			this.form1.get('propertyLeadSubjAdrState').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.propertyLeadSubjAdrState.push(n);
			});
			this.formToSubmit.propertyLeadSubjAdrState = this.propertyLeadSubjAdrState;
		}
		this.propertyLeadSubjAdrDevelopmentName = [];
		if (this.form1.get('propertyLeadSubjAdrDevelopmentName').value) {
			this.form1.get('propertyLeadSubjAdrDevelopmentName').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.propertyLeadSubjAdrDevelopmentName.push(n);
			});
			this.formToSubmit.propertyLeadSubjAdrDevelopmentName = this.propertyLeadSubjAdrDevelopmentName;
		}
		this.formToSubmit.propertyLeadProfileTags = this.propertyLeadProfileTags;

		// employee profile
		this.employeeLeadListingStatus = [];
		if (this.form1.get('employeeLeadListingStatus').value) {
			this.form1.get('employeeLeadListingStatus').value.forEach(element => {
				this.employeeLeadListingStatus.push(element.value);
			});
			this.formToSubmit.employeeLeadListingStatus = this.employeeLeadListingStatus;
		}
		this.employeeLocationIdList = [];
		if (this.form1.get('employeeLocationIdList').value) {
			this.form1.get('employeeLocationIdList').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.locationId : element;
				this.employeeLocationIdList.push(id);
			});
			this.formToSubmit.employeeLocationIdList = this.employeeLocationIdList;
		}
		this.jobLevel = [];
		if (this.form1.get('jobLevel').value) {
			this.form1.get('jobLevel').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.jobLevel.push(v);
			});
			this.formToSubmit.jobLevel = this.jobLevel;
		}
		this.jobCategories = [];
		if (this.form1.get('jobCategories').value) {
			this.form1.get('jobCategories').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.jobCategories.push(v);
			});
			this.formToSubmit.jobCategories = this.jobCategories;
		}

		// owner profile
		this.ownerListingStatus = [];
		if (this.form1.get('ownerListingStatus').value) {
			this.form1.get('ownerListingStatus').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerListingStatus.push(n);
			});
			this.formToSubmit.ownerListingStatus = this.ownerListingStatus;
		}
		this.ownerProfileSubAdrIsland = [];
		if (this.form1.get('ownerProfileSubAdrIsland').value) {
			this.form1.get('ownerProfileSubAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerProfileSubAdrIsland.push(n);
			});
			this.formToSubmit.ownerProfileSubAdrIsland = this.ownerProfileSubAdrIsland;
		}
		this.ownerProfileSubjAdrState = [];
		if (this.form1.get('ownerProfileSubjAdrState').value) {
			this.form1.get('ownerProfileSubjAdrState').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerProfileSubjAdrState.push(n);
			});
			this.formToSubmit.ownerProfileSubjAdrState = this.ownerProfileSubjAdrState;
		}
		this.ownerProfileSubjAdrDevelopmentName = [];
		if (this.form1.get('ownerProfileSubjAdrDevelopmentName').value) {
			this.form1.get('ownerProfileSubjAdrDevelopmentName').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.ownerProfileSubjAdrDevelopmentName.push(n);
			});
			this.formToSubmit.ownerProfileSubjAdrDevelopmentName = this.ownerProfileSubjAdrDevelopmentName;
		}
		this.formToSubmit.ownerProfileTags = this.ownerProfileTags;

		// realtor profile
		this.realtorListingStatus = [];
		if (this.form1.get('realtorListingStatus').value) {
			this.form1.get('realtorListingStatus').value.forEach(element => {
				const v = element != null && typeof element === 'object' ? element.value : element;
				this.realtorListingStatus.push(v);
			});
			this.formToSubmit.realtorListingStatus = this.realtorListingStatus;
		}
		this.realtorAdrIsland = [];
		if (this.form1.get('realtorAdrIsland').value) {
			this.form1.get('realtorAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.realtorAdrIsland.push(n);
			});
			this.formToSubmit.realtorAdrIsland = this.realtorAdrIsland;
		}
		this.realtorAdrState = [];
		if (this.form1.get('realtorAdrState').value) {
			this.form1.get('realtorAdrState').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.realtorAdrState.push(n);
			});
			this.formToSubmit.realtorAdrState = this.realtorAdrState;
		}
		this.formToSubmit.realtorProfileTags = this.realtorProfileTags;

		// contact
		this.contactAdrIsland = [];
		if (this.form1.get('contactAdrIsland').value) {
			this.form1.get('contactAdrIsland').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.contactAdrIsland.push(n);
			});
			this.formToSubmit.contactAdrIsland = this.contactAdrIsland;
		}
		this.contactAdrState = [];
		if (this.form1.get('contactAdrState').value) {
			this.form1.get('contactAdrState').value.forEach(element => {
				const n = element != null && typeof element === 'object' ? element.name : element;
				this.contactAdrState.push(n);
			});
			this.formToSubmit.contactAdrState = this.contactAdrState;
		}
    if (this.form1.get('contactEmail').value) {
      this.formToSubmit.contactEmail = this.form1.get('contactEmail').value;
    }
    if (this.form1.get('reservationId').value) {
      this.formToSubmit.reservationId = this.form1.get('reservationId').value;
    }
    if (this.form1.get('contactFirstName').value) {
      this.formToSubmit.contactFirstName = this.form1.get('contactFirstName').value;
    }
    if (this.form1.get('contactLastName').value) {
      this.formToSubmit.contactLastName = this.form1.get('contactLastName').value;
    }

	// 01-01-2026 Divy : If To date is null or previous than start date then auto focus on To date calender
	if(this.form1.get('formFilterDateStart').value && field && field === 'filterDateStart')
	{
		this.form1.patchValue({
			formFilterDateEnd: null
		});
		this.minFilterEndDate = this.form1.get('formFilterDateStart').value;
		window.setTimeout(() => {
			this.filterDateEndCalender.inputfieldViewChild.nativeElement.focus();
		}, 1);
	}

	// Same behaviour for Sale Date Start → Sale Date End.
	if (this.form1.get('formSaleDateStart').value && field && field === 'saleDateStart') {
		this.form1.patchValue({
			formSaleDateEnd: null
		});
		this.minSaleDateEnd = this.form1.get('formSaleDateStart').value;
		window.setTimeout(() => {
			this.saleDateEndCalender.inputfieldViewChild.nativeElement.focus();
		}, 1);
	}

		this.ownerProfileSelectedShortTermRentalIds = [];
		if (this.form1.get('ownerProfileShortTermRental').value) {
			this.form1.get('ownerProfileShortTermRental').value.forEach(element => {
				const id = element != null && typeof element === 'object' ? element.shortTermRentalId : element;
				this.ownerProfileSelectedShortTermRentalIds.push(id);
			});
			this.formToSubmit.ownerProfileShortTermRentalIdList = this.ownerProfileSelectedShortTermRentalIds;
		}
		this.formToSubmit.contactTags = this.contactTags;


		this.formToSubmit.guestProfile = this.guestProfile;
		this.formToSubmit.guestMasterProfile = this.guestMasterProfile;
		this.formToSubmit.propertyLeadProfile = this.propertyLeadProfile;
		this.formToSubmit.employeeProfile = this.employeeProfile;
		this.formToSubmit.ownerProfile = this.ownerProfile;
		this.formToSubmit.realtorProfile = this.realtorProfile;
		this.formToSubmit.contacts = this.contacts;
		this.formToSubmit.ownerLeadProfile = this.ownerLeadProfile;
		this.formToSubmit.includeRegisteredGuest = this.form1.get('includeRegisteredGuest').value;
		this.formToSubmit.includeProspectGuest = this.form1.get('includeProspectGuest').value;
	}
	onKeyInput(event) {
		let query = event.query;
		this.findTagsWith(query);
		return this.tagSuggestions;
	}

	findTagsWith(queryString: string) {

		this.reportService.findTagsWith(queryString, 0).pipe(first()).subscribe(

			data => {
				console.log('tags are: ' + JSON.stringify(data));
				this.tagSuggestions = data.data.tagSummaryList;
			},
			error => {
				console.log('tags error are: ' + error);
			},
			() => { }
		);


	}
	onSelect(event, tagSource) {
		// assemble the payload manually since we are using primeng
		console.log('onSelect: ' + JSON.stringify(event));
		let data: any = {};
		data.tagId = event.tagId;
		if (tagSource == '10') {
			if (this.ownerLeadProfileTags == undefined) {
				this.ownerLeadProfileTags = [];
			}
			this.ownerLeadProfileTags.push(data.tagId);
		} else if (tagSource == '20') {
			if (this.propertyLeadProfileTags == undefined) {
				this.propertyLeadProfileTags = [];
			}
			this.propertyLeadProfileTags.push(data.tagId);
		}
		else if (tagSource == '50') {
			if (this.ownerProfileTags == undefined) {
				this.ownerProfileTags = [];
			}
			this.ownerProfileTags.push(data.tagId);
		}
		else if (tagSource == '80') {
			if (this.contactTags == undefined) {
				this.contactTags = [];
			}
			this.contactTags.push(data.tagId);
		}
		else if (tagSource == '90') {
			if (this.realtorProfileTags == undefined) {
				this.realtorProfileTags = [];
			}
			this.realtorProfileTags.push(data.tagId);
		}
		else if (tagSource == '100') {
			if (this.guestMasterProfileTags == undefined) {
				this.guestMasterProfileTags = [];
			}
			this.guestMasterProfileTags.push(data.tagId);
		}
		else if (tagSource == '110') {
			if (this.guestProfileTags == undefined) {
				this.guestProfileTags = [];
			}
			this.guestProfileTags.push(data.tagId);
		}
	}


	onUnselect(event, tagSource) {
		// assemble the payload manually since we are using primeng
		let data: any = {};
		data.tagId = event.tagId;
		if (this.ownerProfileTags == undefined) {
			this.ownerProfileTags = [];
		}
		console.log('onUnselect: ' + JSON.stringify(data));
		if (tagSource == '10') {
			const index: number = this.ownerLeadProfileTags.indexOf(data.tagId);
			this.ownerLeadProfileTags.splice(index, 1);
		} else if (tagSource == '20') {
			const index: number = this.propertyLeadProfileTags.indexOf(data.tagId);
			this.propertyLeadProfileTags.splice(index, 1);
		}
		else if (tagSource == '50') {
			const index: number = this.ownerProfileTags.indexOf(data.tagId);
			this.ownerProfileTags.splice(index, 1);
		}
		else if (tagSource == '80') {
			const index: number = this.contactTags.indexOf(data.tagId);
			this.contactTags.splice(index, 1);
		}
		else if (tagSource == '90') {
			const index: number = this.realtorProfileTags.indexOf(data.tagId);
			this.realtorProfileTags.splice(index, 1);
		}
		else if (tagSource == '100') {
			const index: number = this.guestMasterProfileTags.indexOf(data.tagId);
			this.guestMasterProfileTags.splice(index, 1);
		}
		else if (tagSource == '110') {
			const index: number = this.guestProfileTags.indexOf(data.tagId);
			this.guestProfileTags.splice(index, 1);
		}

		//console.log('onUnselect: ' + JSON.stringify(this.tagSelectForm.value.tagJoin));
		//this.tagsSelectedEvent.emit(this.tagSelectForm.value.tagJoin);
	}

	buildSearchForm2() {
		this.form2ToSubmit = {};

		// sale year
		if (this.form2.get('formSaleYear').value) {
			this.selectedSaleYear = this.form2.get('formSaleYear').value;
			this.form2ToSubmit.saleYear = this.selectedSaleYear;
		}
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList().pipe(first()).subscribe(

			data => {
				this.shortTermRentals = data.data.propertySummaryList;
				// Auto filter input shortTermRentalId / propertyCode (e.g. "HKH-236" from URL)
				if(this.shortTermRentalId != null || this.propertyCode != null)
				{
				let formShortTermRentalIds = this.form1.get('formShortTermRentalIds').value;
				if(formShortTermRentalIds == null)
				{
					formShortTermRentalIds = [];
				}
				const codeNorm = this.propertyCode ? this.propertyCode.trim().toLowerCase() : null;
				this.shortTermRentals.forEach(shortTermRental => {
					const matchById = this.shortTermRentalId != null
						&& shortTermRental.shortTermRentalId == this.shortTermRentalId;
					const matchByCode = codeNorm != null
						&& (shortTermRental.propertyCode || '').toLowerCase() === codeNorm;
					if(matchById || matchByCode)
					{
						formShortTermRentalIds.push(shortTermRental);
						this.form1.patchValue({
							formShortTermRentalIds: formShortTermRentalIds
						});

						if(this.startDate)
						{
							this.form1.patchValue({
								formStartDate: this.addTimeOffsetToLocalDateTime(new Date(this.startDate))
							});
						}
						if(this.endDate)
						{
							this.form1.patchValue({
								formEndDate: this.addTimeOffsetToLocalDateTime(new Date(this.endDate))
							});
						}
						this.searchClick();
					}
				});
			}
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	loadPropertiesYieldMax() {
		this.formLoading = true;
		this.reportService.propertySummaryListYieldMax().pipe(first()).subscribe(

			data => {
				this.yielMaxProperties = data.data.propertySummaryList;

				// Auto filter input propertyId / propertyCode (e.g. "HKH-236" from URL)
				if(this.shortTermRentalId != null || this.propertyCode != null)
					{
					let formYielMaxPropertyIds = this.form1.get('formYielMaxPropertyIds').value;
					if(formYielMaxPropertyIds == null)
					{
						formYielMaxPropertyIds = [];
					}
					const codeNorm = this.propertyCode ? this.propertyCode.trim().toLowerCase() : null;
					this.yielMaxProperties.forEach(yielMaxProperty => {
						const matchByExt = this.shortTermRentalId != null
							&& yielMaxProperty.extSystemId == this.shortTermRentalId;
						const matchByCode = codeNorm != null
							&& (yielMaxProperty.propertyCode || '').toLowerCase() === codeNorm;
						if(matchByExt || matchByCode)
						{
							let selectedYielMaxPropertyRateBucketIds = [];
							formYielMaxPropertyIds.push(yielMaxProperty.propertyId);
							selectedYielMaxPropertyRateBucketIds.push(yielMaxProperty.rateBucketId);
							if(!this.formToSubmit)
							{
								this.formToSubmit = {};
							}
							this.formToSubmit.yielMaxPropertyRateBucketIdList = selectedYielMaxPropertyRateBucketIds;
							this.form1.patchValue({
								formYielMaxPropertyIds: formYielMaxPropertyIds
							});
							this.searchClick();
						}
					});
				}
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	loadDevelopmentsYieldMax() {
		this.formLoading = true;
		this.reportService.developmentSummaryListYieldMax().pipe(first()).subscribe(
			data => {
				this.yielMaxDevelopments = [];
				let developments = data.data.developmentSummaryList;
				developments.forEach(element => {
					let obj = {
						label : element, value : element
					}
					this.yielMaxDevelopments.push(obj);
				});
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}
	loadRateBucketsYieldMax() {
		try {
			this.reportService.rateBucketListYieldMax()
				.subscribe(
					res => {
						this.yielMaxRateBuckets = res.data.rateBuckets;
					},
					err => {
						console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: err.message, life: 3000 });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
		}
	}
	loadDevelopments() {
		this.formLoading = true;
		this.reportService.developmentSummaryList().pipe(first()).subscribe(

			data => {
				this.developments = data.data.developmentSummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}
	loadRateBuckets() {
		try {
			this.rateBucketService.findAll()
				.subscribe(
					res => {
						this.rateBuckets = res.data.rateBuckets;
					},
					err => {
						console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: err.message, life: 3000 });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
		}
	}
	openTagAddModalDialog() {
		{
			this.tagAddModalDialogRef = this.dialog.open(TagAddModalComponent, {
				hasBackdrop: true
			});
			let instance = this.tagAddModalDialogRef.componentInstance;

			// pass the tagType through from the helper to the popup.
			instance.tagType = 4;
		}
	}
	/**
	 * new Date('String Date') creates date with timezone offset hence this method add timezone hours
	 * @param datetime
	 * @returns
	 */
	addTimeOffsetToLocalDateTime(datetime) {
		let offsetMin = datetime.getTimezoneOffset();
		// If positive means timezone is in minus of UTC
		if(offsetMin > 0)
		{
			return new Date(datetime.getTime() + (datetime.getTimezoneOffset() * 60000));
		}
		else
		{
			return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
		}
	}
}
